<mat-toolbar class="toolbar">
   <span class="toolbar-text">{{data.type}}</span>
  <button mat-icon-button aria-label="close dialog" mat-dialog-close class="margin-auto">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<div class="alignPos">
  <div style="margin-left: 22px; margin-top: 35px; font-size: 16px;"> {{data.mess}}</div>
</div>
<div class="buttonS">
  <button mat-flat-button class="okBtn" (click)="onClickOk()"> Close </button>
</div>